import { render, staticRenderFns } from "./InvN_Items_List.vue?vue&type=template&id=a37a3d08"
import script from "./InvN_Items_List.vue?vue&type=script&lang=js"
export * from "./InvN_Items_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports